import React, { useState } from "react";
import { SvgIcons } from "../components/SVG/SvgIcons";
import Navbar from "../components/Navbar";
import Config from '../core/constants/Config';
import Footer from "../components/Footer";

const Contact = () => {
  const [contactDetails, setContactDetails] = useState({
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const submitContactDetailsForm = async (e) => {
    e.preventDefault();
  
    // Prepare request body
    const requestBody = {
      email: contactDetails.email,
      phone: contactDetails.phone,
      message: contactDetails.message,
    };
  
    try {
      // Send a POST request to your backend
      const response = await fetch(`${Config.local_public_endpoint}/contactsWithDetailsApi`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
  
      // Handle response
      if (response.ok) {
        const result = await response.json();
        console.log("Message sent successfully:", result);
        alert("Thank you! Your message has been sent successfully.");
        clearForm();
      } else {
        console.error("Failed to send message:", response.status);
        alert("Something went wrong. Please try again later.");
      }
    } catch (error) {
      console.error("Error while sending message:", error);
      alert("Network error. Please check your connection.");
    }

  

    e.preventDefault();
   clearForm();
  };

  const clearForm=()=>{
    setContactDetails({
      email: "",
      phone: "",
      message: "",
    });
  }

  return (
    <>

    <Navbar />
      <div className="w-[100%] bg-gray-100 pb-[10rem]">
      
        <div className="w-[100%] flex justify-center items-center">
          <div className="w-[80%] mt-[5rem]">
            <div className="w-[100%] flex justify-center font-bold font-sans text-[25px] sm:text-[40px]">
              Get in touch!
            </div>
            <div className="w-[100%] flex justify-center text-[20px] sm:text-[30px] text-gray-500">
              
            </div>
            <div className="w-[100%] sm:flex justify-between">
              <div className="w-[100%] sm:w-[20%] mt-[5rem] cursor-pointer">
                <div className="w-[100%] rounded-[10px] bg-red-500   h-[180px] flex justify-center items-center">
                  <div className="w-[100%]">
                    <div className="w-[100%] flex justify-center py-[10px] text-[20px] text-white">
                      <SvgIcons IconKey="LOCATION" size="40" />
                    </div>
                    <div className="w-[100%] text-white flex justify-center py-[10px] text-[20px]">
                      Locations
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[100%] sm:w-[20%] mt-[5rem] cursor-pointer">
                <div className="w-[100%] rounded-[10px] bg-red-500  hover:text-red-500 h-[180px] flex justify-center items-center">
                  <div className="w-[100%]">
                    <div className="w-[100%] flex justify-center py-[10px] text-[20px] text-white">
                      <SvgIcons IconKey="PHONE" size="40" />
                    </div>
                    <div className="w-[100%] text-white flex justify-center py-[10px] text-[20px]">
                      Phone
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-[100%] sm:w-[20%] mt-[5rem] cursor-pointer">
                <div className="w-[100%] rounded-[10px] bg-red-500  hover:text-red-500 h-[180px] flex justify-center items-center">
                  <div className="w-[100%]">
                    <div className="w-[100%] flex justify-center py-[10px] text-[20px] text-white">
                      <SvgIcons IconKey="MAIL" size="40" />
                    </div>
                    <div className="w-[100%] text-white flex justify-center py-[10px] text-[20px]">
                      Message
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-[100%] mt-[5rem]  rounded-[10px]">
              <form onSubmit={submitContactDetailsForm} className="space-y-8">
                <div>
                  <label
                    htmlFor="email"
                    className="block mb-2 text-[16px]   font-medium  text-gray-900"
                  >
                    Your email
                  </label>
                  <input
                    onChange={handleChange}
                    value={contactDetails.email}
                    name="email"
                    type="email"
                    id="email"
                    className="text-[17px] shadow-sm bg-gray-50 border border-gray-300  rounded-lg focus:ring-primary-500 focus:border-primary-500 block w-full p-2.5  placeholder-gray-400 focus:ring-primary-500 focus:border-primary-500 shadow-sm-light"
                    placeholder="name@flowbite.com"
                    required
                  />
                </div>
                <div>
                  <label
                    htmlFor="phone"
                    className="block mb-2 text-[16px]   font-medium text-gray-900"
                  >
                    phone
                  </label>
                  <input
                    onChange={handleChange}
                    value={contactDetails.phone}
                    name="phone"
                    type="text"
                    id="phone"
                    className="text-[17px] block p-3 w-full  bg-gray-50 rounded-lg border border-gray-300 shadow-sm focus:ring-primary-500 focus:border-primary-500  placeholder-gray-400 dark:focus:ring-primary-500 focus:border-primary-500 shadow-sm-light"
                    placeholder="Let us know how we can help you"
                    required
                  />
                </div>
                <div className="sm:col-span-2">
                  <label
                    htmlFor="message"
                    className="block mb-2 text-[16px]   font-medium text-gray-900"
                  >
                    Your message
                  </label>
                  <textarea
                    onChange={handleChange}
                    value={contactDetails.message}
                    name="message"
                    id="message"
                    rows="6"
                    className="text-[17px] block p-2.5 w-full  text-gray-900 bg-gray-50 rounded-lg shadow-sm border border-gray-300 focus:ring-primary-500 focus:border-primary-500  placeholder-gray-400 focus:ring-primary-500 focus:border-primary-500"
                    placeholder="Leave a comment..."
                  ></textarea>
                </div>
                <button
                  type="submit"
                  className="py-3 px-5 font-medium text-center text-white text-[17px] rounded-lg bg-primary-700 sm:w-fit hover:bg-primary-800 focus:ring-4 focus:outline-none focus:ring-primary-300 bg-red-500 hover:bg-primary-700 focus:ring-primary-800"
                >
                  Send message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
